export class GrupoCarteiraSelecaoModel {
  id: string;
  nome: string;
}

export class CarteiraSelecaoModel {
  id: string;
  nome: string;
}

export class AssociacaoModel {
  grupoCarteiraNome: string;
  carteirasIds: string[];
}
